import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';
import { buildSepaQrContent } from '../utils/sepaQr.js';

/** Zeigt einen SEPA-QR-Code (EPC069-12) für die Rechnung. size = Pixel für QR-Kante (default 140). */
export function SepaQrImage({ settings, documentData, reminderFee = 0, size = 140 }) {
  const [dataUrl, setDataUrl] = useState(null);
  const itemsTotal = (documentData?.items || []).reduce((acc, i) => acc + i.quantity * i.price, 0);
  const totalNet = itemsTotal + Number(reminderFee) || 0;
  const totalEur = totalNet * 1.19;

  useEffect(() => {
    const iban = (settings?.iban || '').replace(/\s/g, '');
    if (!iban || iban.length < 15) return;
    const content = buildSepaQrContent({
      iban,
      bic: settings?.bic || '',
      recipient: settings?.companyName || '',
      amountEur: totalEur,
      reference: documentData?.id ? `Rechnung ${documentData.id}` : '',
      creditorId: settings?.creditorId || undefined,
    });
    QRCode.toDataURL(content, { width: size, margin: 1 }).then(setDataUrl).catch(() => {});
  }, [settings?.iban, settings?.bic, settings?.companyName, settings?.creditorId, documentData?.id, totalEur, size]);

  if (!dataUrl) return null;
  return (
    <div className="flex flex-col items-center gap-1">
      <img src={dataUrl} alt="SEPA-QR" width={size} height={size} className="border border-slate-200 rounded" />
      <span className="text-xs text-slate-500 text-center">Scan zum<br />Überweisen</span>
    </div>
  );
}
